export const translations = {
  en: {
    nav: { experience: "Experience", studio: "Studio", schedule: "Schedule", pricing: "Pricing", location: "Location", account: "Account", reserve: "Reserve" },
    menu: { open: "Menu", close: "Close", home: "Home" },
    coach: {
      overline: "Your coaches",
      role: "Head Coach",
      disciplines: { spinning: "Spinning · Head Coach", floor: "Functional Aerobics · Dancefit" },
      tagline: "Rhythm, strength and discipline in every beat.",
    },
    loader: { top1: "where", top2: "*your* RIDE", bottom1: "BECOMES", bottom2: "*art.*" },
    heroTitle: ["*Signature* RIDES *in a* STUDIO", "*of* BLACK & GOLD."],
    discover: {
      split1: ["YOUR MOST", "*important* HOUR"],
      split2: ["DESERVES TO", "LAST *forever.*"],
      statement: "Apex Ride is a luxury indoor cycling studio that transforms 50 minutes into pure strength.",
      body: "Each Apex class holds 20 riders in a candlelit room of black and gold. Immersive sound, choreographed rhythm and one instructor guiding every beat — so that your ride is felt with exceptional precision and intensity, exactly as it should be.",
      cta: "*Reserve your* BIKE",
    },
    stepper: {
      uptitle: "*the* ESSENCE *of* APEX",
      title: ["*where* RHYTHM", "*meets* STRENGTH"],
      steps: ["*From* BIKE,", "*to* BEAT,", "*to* STRENGTH."],
    },
    hero2a: { uptitle: "*a* RIDE BUILT *for* PERFECTION", title: ["*so* THAT YOU", "BECOME *art.*"] },
    diptych: {
      title: "Ridden once. Felt forever.",
      lead: "You ride for 50 minutes, then carry it with you for days. It deserves to be extraordinary.",
      body: "Apex transforms your workout into a ritual, crafted through a balance of light, sound and rhythm so that we can push every limit. Every reservation begins with your bike: choose your exact spot on the studio map, bring your people, and let us guide you through every beat of the Apex experience.",
      cta: "DISCOVER *the* EXPERIENCE",
      founderQuote: "“Technology often pulls us away from what's real. Apex does the opposite — we use the bike to bring the mind back to the physical form.”",
      founderName: "ALEJANDRO RÍOS,",
      founderRoleItalic: "founder of",
    },
    hero2b: { uptitle: "*your* EFFORT", title: ["*will forever*", "BE A MASTERPIECE."] },
    grid: { cta: "*Explore the* STUDIO" },
    live: {
      badge: "THE STUDIO · LIVE",
      title: ["*feel* THE BEAT."],
      cta: "RESERVE *your* SPOT",
      musicOn: "Music on",
      musicOff: "Music off",
    },
    quote: {
      lines: [
        ["Today's sweat", "becomes"],
        ["tomorrow's strength:", "every beat"],
        ["strengthens the heart,", "calms"],
        ["the mind and awakens", "the best"],
        ["version", "of you."],
      ],
      author: "The Apex Philosophy",
    },
    schedule: {
      overline: "*the* WEEK *at* APEX",
      heading: "THE *full* SCHEDULE",
      intro: "Every class of the week, at a glance. Tap any one to reserve your bike or your spot.",
      rideShort: "Spinning",
      floorShort: "Floor class",
      cta: "RESERVE",
    },
    pricing: {
      overline: "*ride* MORE, *pay* LESS",
      heading: "PACKAGES *&* MEMBERSHIPS",
      note: "Have a coupon? Apply it at checkout. Every purchase includes an automatic receipt.",
      perClass: "per class",
      // Descuento de bienvenida, visible en la web.
      promoOverline: "WELCOME GIFT",
      promoTitle: "40% off *one* class.",
      promoBody: "Use the code below on any class you like — your first one, or your hundredth. It is yours to spend whenever it suits you.",
      promoOnce: "One per person",
      promoCodeLabel: "Code",
      promoCopy: "Copy",
      promoCopied: "Copied",
      promoCta: "Book a class",
      oneTime: "one time",
      perMonth: "1 month",
      singleName: "Single Ride",
      singleNote: "Drop-in spinning with Glory — one ride, one bike. No commitment.",
      floorName: "Floor Class",
      floorNote: "Functional aerobics and Dancefit with Graciela. Drop-in only — no packages.",
      orPackages: "Or save with a package",
      covers: { ride: "Spinning", floor: "Floor classes", any: "Everything" },
      buy: "BUY PACKAGE",
      buying: "OPENING CHECKOUT…",
      packageNote: "Packages are linked to your account. If you don't have one yet, you'll create it in a moment — it takes less than a minute. The Unlimited pass covers one spot per class.",
      policyTitle: "Cancellation policy",
      policy: [
        "Cancel or reschedule up to 1 hour before — free of charge.",
        "Less than 1 hour before — a $5 fee applies.",
        "Rescheduling available up to 30 minutes before class.",
      ],
    },
    reassurance: {
      line1: "Your strength deserves to be ridden.",
      line2: "We'd be honored to ride it with you.",
      cta: "*Reserve your* BIKE",
    },
    location: {
      overline: "*find* THE STUDIO",
      heading: "WHERE *the ride* LIVES.",
      addressLabel: "Address",
      directions: "Get directions",
      storefront: "See the storefront",
      provisional: "Provisional location — the final address will be updated soon.",
    },
    account: {
      overline: "*your* APEX ACCOUNT",
      heading: "SIGN IN *or* JOIN.",
      signIn: "Sign in",
      createAccount: "Create account",
      name: "Full name",
      email: "Email",
      phoneOptional: "Mobile (optional)",
      password: "Password",
      privacyNote: "Your password is stored encrypted. We never see it.",
      showPassword: "Show password",
      hidePassword: "Hide password",
      forgotLink: "Forgot your password?",
      forgotTitle: "Recover your password",
      forgotIntro: "Enter the email of your account and we will send you a link to set a new password.",
      forgotSend: "SEND ME THE LINK",
      forgotSentTitle: "Check your email",
      forgotSentBody: "If that email belongs to an Apex Ride account, the link is already on its way. It expires in one hour.",
      forgotSentSpam: "Not there after a minute? Check the spam folder.",
      backToSignIn: "← Back to sign in",
      resetTitle: "New password",
      resetIntro: "Choose a new password for your account. You will be signed in right away.",
      newPassword: "New password",
      resetSave: "SAVE AND SIGN IN",
      resetMin: "At least 6 characters.",
      genericError: "Something went wrong. Please try again.",
      welcome: "Welcome back",
      signOut: "Sign out",
      membership: "Membership",
      unlimited: "Unlimited classes",
      classesLeft: "classes left",
      validUntil: "Valid until",
      noMembership: "You don't have an active membership yet. Choose a plan:",
      payNote: "Payment is completed on Stripe's secure page.",
      choose: "CHOOSE",
      reward: "Your reward",
      freeClasses: "free classes available",
      rewardProgress: "{n} more classes until your next free class.",
      totalBooked: "{n} classes booked in total.",
      history: "Booking history",
      noBookings: "You have no bookings yet.",
      bookNow: "Book your first ride →",
      bikes: "Bikes",
      byMembership: "Membership",
      freeTag: "Free class",
      reschedule: "Change class",
      profile: "Profile",
      save: "Save changes",
      saved: "Saved ✓",
      guestTitle: "Booked as a guest?",
      guestSub: "Find your reservations with your email — no account needed.",
      guestSearch: "Find",
      guestFound: "Your reservations",
      guestNone: "No reservations found for that email.",
    },
    manage: {
      overline: "*your* RESERVATION",
      heading: "MANAGE *your* CLASS.",
      loading: "Loading your reservation…",
      notFound: "We could not find that reservation. Check the link in your receipt email.",
      genericError: "Something went wrong. Please try again.",
      receipt: "Receipt",
      yourClass: "Your class",
      coach: "Coach",
      spots: "Spots",
      bikes: "Bikes",
      statusConfirmed: "Confirmed",
      statusOther: "This reservation is no longer active.",
      movedNote: "Moved on {d}.",
      changeCta: "CHANGE MY CLASS",
      cancelChange: "Keep this class",
      pickTitle: "Pick the new class",
      pickIntro: "Same discipline, same number of spots — nothing more to pay. Only classes with room are shown.",
      sameKindNote: "You are booked for {kind}, so you can move to another {kind} class.",
      kindRide: "spinning",
      kindFloor: "floor class",
      full: "Full",
      noOptions: "There are no other classes with room right now. Write to the studio and they will help you.",
      confirmMove: "MOVE ME TO THIS CLASS",
      moving: "Moving…",
      moved: "Done — your class was moved.",
      movedBody: "We just sent you a new receipt with the correct day and time.",
      tooLate: "There is less than an hour left before your class, so it can no longer be changed here. Call the studio at {phone} and they will help you.",
      windowNote: "You can change your class free of charge up to {n} minutes before it starts.",
      backHome: "← Back to the studio",
      myAccount: "My account →",
    },
    footer: {
      tagline: "Luxury indoor cycling. Black & gold.",
      hours: "Hours",
      hoursWeek: "Mon – Fri · from 5:40 AM · evenings until 9:00 PM",
      hoursWeekend: "Sat · 7:00 AM – 11:30 PM   ·   Sun · 8:30 AM",
      contact: "Contact",
      rights: "All rights reserved.",
      madeBy: "Site by",
      payments: "Secure payments processed by Stripe.",
      stay: "Stay in touch with the studio",
      emailPlaceholder: "Your email",
      subscribed: "Thank you — we'll keep you posted.",
      invalidEmail: "Please enter a valid email.",
      accessibility: "Accessibility",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
    },
    booking: {
      overline: "*the* APEX EXPERIENCE",
      chooseClass: "CHOOSE *your* CLASS",
      chooseBike: "CHOOSE *your* BIKE",
      with: "with",
      spots: "bikes left",
      soldOut: "SOLD OUT",
      past: "FINISHED",
      back: "← Back to schedule",
      instructor: "INSTRUCTOR",
      legendAvailable: "Available",
      legendSelected: "Selected",
      legendBooked: "Booked",
      mapHint: "Select one or more bikes on the map.",
      summary: "YOUR RESERVATION",
      bikes: "Bikes",
      bike: "Bike",
      perBike: "per bike",
      subtotal: "Subtotal",
      discount: "Discount",
      total: "Total",
      coupon: "Coupon code",
      apply: "APPLY",
      couponInvalid: "Invalid coupon",
      couponApplied: "applied",
      name: "Full name",
      email: "Email",
      pay: "CONFIRM & PAY",
      processing: "PROCESSING PAYMENT…",
      paymentsOff: "Card payments are not active right now.",
      payStripe: "PAY SECURELY",
      securePay: "You will be redirected to Stripe's secure page to pay by card, Apple Pay or Google Pay. We never see or store your card details.",
      paySuccess: "Payment confirmed",
      payCanceled: "Payment canceled — your bikes were released.",
      payChecking: "Confirming your payment…",
      errRequired: "Please complete your name and email.",
      errBikes: "Select at least one bike on the map.",
      errConflict: "Some of your bikes were just taken. Please review the map.",
      // Clases de suelo (aeróbicos y dancefit): plaza, no bicicleta.
      chooseSpots: "RESERVE *your* SPOT",
      spotsLeft: "spots left",
      spotsHint: "No bike in this class — choose how many spots you need.",
      howMany: "How many spots?",
      spotsLabel: "Spots",
      spotLabel: "Spot",
      perSpot: "per spot",
      spotsAvailable: "available",
      errSpots: "Choose at least one spot.",
      errSpotsConflict: "The class just filled up. Please choose fewer spots.",
      payCanceledSpots: "Payment canceled — your spots were released.",
      floorNote: "Free classes are earned and used on spinning only.",
      hasPackageSignIn: "This email has an active package. Sign in to use it on this booking — otherwise you will be charged again.",
      signInToUse: "Sign in to use it",
      packageHint: "Riding often? With a package each class costs from {p}.",
      seePackages: "See packages",
      min: "min",
      freeClassLine: "Free class (reward)",
      freeClassAvailable: "You have a free class — it will be applied to this booking.",
      rewardProgress: "{n} more classes until your free class.",
      membershipLine: "Membership covers",
      membershipUse: "Use my membership",
      membershipLeft: "left",
      acceptTerms: "I have read and accept the",
      termsLink: "Terms & Conditions",
      errTerms: "You must accept the Terms & Conditions to book.",
      couponFirstOnly: "You have already used your welcome discount.",
      couponOneClass: "off one class",
      promoLine: "{pct}% off one class, yours to use whenever — code",
      promoAtCheckout: "You have {pct}% off one class with the code {code}. You apply it when you pay, on whichever class you like.",
      haveDiscount: "You have a 40% discount available",
      haveDiscountNote: "Use it on this class, or keep it for another — it is yours either way.",
      useDiscount: "USE IT NOW",
      discountUsedUp: "You have already used your welcome discount.",
      // El carrito: varias clases en una sola compra.
      addToCart: "ADD TO MY BOOKING",
      addToCartHint: "Add as many classes as you like and pay for all of them at once.",
      addedToCart: "Class added. Pick another one, or go to pay.",
      alreadyInCart: "That class is already in your booking.",
      cartLimit: "Up to {n} classes in one purchase.",
      goToCart: "GO TO PAY",
      addMore: "← Add another class",
      inCart: "ADDED",
      cartHeading: "REVIEW *your* CLASSES.",
      cartIntro: "Add all the classes you want and pay for them in one go — handy if you have a package.",
      cartEmpty: "You have not added any class yet.",
      remove: "Remove",
      classWord: "class",
      classesWord: "classes",
      seatWord: "spot",
      seatsWord: "spots",
      bikeWord: "bike",
      bikesWord: "bikes",
      refreshMap: "Refresh availability",
    },
    receipt: {
      confirmed: "PAYMENT *confirmed.*",
      confirmedMany: "{n} CLASSES *booked.*",
      changeNote: "You can change any class from your receipt, up to 60 minutes before it starts.",
      receiptNo: "Receipt",
      klass: "Class",
      date: "Date",
      time: "Time",
      instructor: "Instructor",
      bikes: "Bikes",
      spots: "Spots",
      total: "Total paid",
      emailNote: "An automatic receipt was sent to",
      again: "BOOK ANOTHER RIDE",
      home: "BACK TO HOME",
      rewardEarned: "🎉 You just earned a free class! It's ready for your next booking.",
    },
  },
  es: {
    nav: { experience: "Experiencia", studio: "Estudio", schedule: "Horario", pricing: "Precios", location: "Locación", account: "Cuenta", reserve: "Reservar" },
    menu: { open: "Menú", close: "Cerrar", home: "Inicio" },
    coach: {
      overline: "Tus coaches",
      role: "Entrenadora principal",
      disciplines: { spinning: "Spinning · Entrenadora principal", floor: "Aeróbicos Funcionales · Dancefit" },
      tagline: "Ritmo, fuerza y disciplina en cada beat.",
    },
    loader: { top1: "donde", top2: "*tu* RODADA", bottom1: "SE HACE", bottom2: "*arte.*" },
    heroTitle: ["*Rodadas* DE FIRMA *en un* ESTUDIO", "*de* NEGRO & ORO."],
    discover: {
      split1: ["TU HORA MÁS", "*importante*"],
      split2: ["MERECE DURAR", "*para siempre.*"],
      statement: "Apex Ride es un estudio de ciclismo indoor de lujo que transforma 50 minutos en pura fuerza.",
      body: "Cada clase de Apex recibe a 20 riders en una sala a media luz de negro y oro. Sonido inmersivo, ritmo coreografiado y un instructor guiando cada beat — para que tu rodada se sienta con una precisión e intensidad excepcionales, exactamente como debe ser.",
      cta: "*Reserva tu* BICI",
    },
    stepper: {
      uptitle: "*la* ESENCIA *de* APEX",
      title: ["*donde el* RITMO", "*encuentra la* FUERZA"],
      steps: ["*De la* BICI,", "*al* RITMO,", "*a la* FUERZA."],
    },
    hero2a: { uptitle: "*una* RODADA HECHA *para la* PERFECCIÓN", title: ["*para que* TÚ", "TE VUELVAS *arte.*"] },
    diptych: {
      title: "Se rueda una vez. Se siente para siempre.",
      lead: "Ruedas 50 minutos y lo llevas contigo por días. Merece ser extraordinario.",
      body: "Apex transforma tu entrenamiento en un ritual, creado con un balance de luz, sonido y ritmo para empujar cada límite. Toda reserva comienza con tu bici: elige tu lugar exacto en el mapa del estudio, trae a tu gente y déjanos guiarte por cada beat de la experiencia Apex.",
      cta: "DESCUBRE *la* EXPERIENCIA",
      founderQuote: "“La tecnología suele alejarnos de lo real. Apex hace lo contrario — usamos la bici para devolver la mente a su forma física.”",
      founderName: "ALEJANDRO RÍOS,",
      founderRoleItalic: "fundador de",
    },
    hero2b: { uptitle: "*tu* ESFUERZO", title: ["*será por siempre*", "UNA OBRA MAESTRA."] },
    grid: { cta: "*Explora el* ESTUDIO" },
    live: {
      badge: "EL ESTUDIO · EN VIVO",
      title: ["*siente* EL BEAT."],
      cta: "RESERVA *tu* LUGAR",
      musicOn: "Música on",
      musicOff: "Música off",
    },
    quote: {
      lines: [
        ["El sudor de hoy", "es la fuerza"],
        ["de mañana:", "cada beat"],
        ["fortalece el corazón,", "calma"],
        ["la mente y despierta", "la mejor"],
        ["versión", "de ti."],
      ],
      author: "Filosofía Apex",
    },
    schedule: {
      overline: "*la* SEMANA *en* APEX",
      heading: "EL HORARIO *completo*",
      intro: "Todas las clases de la semana, de un vistazo. Toca cualquiera para reservar tu bici o tu lugar.",
      rideShort: "Spinning",
      floorShort: "Clase de suelo",
      cta: "RESERVAR",
    },
    pricing: {
      overline: "*rueda* MÁS, *paga* MENOS",
      heading: "PAQUETES *&* MEMBRESÍAS",
      note: "¿Tienes un cupón? Aplícalo al pagar. Toda compra incluye recibo automático.",
      perClass: "por clase",
      // Descuento de bienvenida, visible en la web.
      promoOverline: "REGALO DE BIENVENIDA",
      promoTitle: "40% en *una* clase.",
      promoBody: "Usa el código de abajo en la clase que t\u00fa quieras \u2014 la primera, o la n\u00famero cien. Es tuyo y lo gastas cuando te convenga.",
      promoOnce: "Uno por persona",
      promoCodeLabel: "C\u00f3digo",
      promoCopy: "Copiar",
      promoCopied: "Copiado",
      promoCta: "Reservar una clase",
      oneTime: "pago único",
      perMonth: "1 mes",
      singleName: "Clase Individual",
      singleNote: "Spinning suelto con Glory — una rodada, una bici. Sin compromiso.",
      floorName: "Clase de Suelo",
      floorNote: "Aeróbicos funcionales y Dancefit con Graciela. Solo suelta — sin paquetes.",
      orPackages: "O ahorra con un paquete",
      covers: { ride: "Spinning", floor: "Clases de suelo", any: "Todo" },
      buy: "COMPRAR PAQUETE",
      buying: "ABRIENDO EL PAGO…",
      packageNote: "Los paquetes van ligados a tu cuenta. Si todavía no tienes una, la creas en un momento — es menos de un minuto. El Ilimitado cubre un lugar por clase.",
      policyTitle: "Política de cancelación",
      policy: [
        "Cancela o reprograma hasta 1 hora antes — sin costo.",
        "Con menos de 1 hora — se aplica un cargo de $5.",
        "Reprogramación disponible hasta 30 minutos antes de la clase.",
      ],
    },
    reassurance: {
      line1: "Tu fuerza merece ser rodada.",
      line2: "Será un honor rodarla contigo.",
      cta: "*Reserva tu* BICI",
    },
    location: {
      overline: "*encuentra* EL ESTUDIO",
      heading: "DONDE *vive* LA RODADA.",
      addressLabel: "Dirección",
      directions: "Cómo llegar",
      storefront: "Ver la fachada",
      provisional: "Ubicación provisional — la dirección final se actualizará pronto.",
    },
    account: {
      overline: "*tu* CUENTA APEX",
      heading: "INICIA SESIÓN *o* REGÍSTRATE.",
      signIn: "Iniciar sesión",
      createAccount: "Crear cuenta",
      name: "Nombre completo",
      email: "Correo electrónico",
      phoneOptional: "Móvil (opcional)",
      password: "Contraseña",
      privacyNote: "Tu contraseña se guarda cifrada. Nunca la vemos.",
      showPassword: "Mostrar contraseña",
      hidePassword: "Ocultar contraseña",
      forgotLink: "¿Olvidaste tu contraseña?",
      forgotTitle: "Recupera tu contraseña",
      forgotIntro: "Escribe el correo de tu cuenta y te mandamos un enlace para poner una contraseña nueva.",
      forgotSend: "ENVIARME EL ENLACE",
      forgotSentTitle: "Revisa tu correo",
      forgotSentBody: "Si ese correo pertenece a una cuenta de Apex Ride, el enlace ya va en camino. Caduca en una hora.",
      forgotSentSpam: "¿No aparece en un minuto? Mira en la carpeta de spam.",
      backToSignIn: "← Volver a iniciar sesión",
      resetTitle: "Contraseña nueva",
      resetIntro: "Elige una contraseña nueva para tu cuenta. Entrarás directamente.",
      newPassword: "Contraseña nueva",
      resetSave: "GUARDAR Y ENTRAR",
      resetMin: "Mínimo 6 caracteres.",
      genericError: "Algo salió mal. Inténtalo de nuevo.",
      welcome: "Bienvenido de vuelta",
      signOut: "Cerrar sesión",
      membership: "Membresía",
      unlimited: "Clases ilimitadas",
      classesLeft: "clases restantes",
      validUntil: "Válida hasta",
      noMembership: "Aún no tienes una membresía activa. Elige un plan:",
      payNote: "El pago se completa en la página segura de Stripe.",
      choose: "ELEGIR",
      reward: "Tu recompensa",
      freeClasses: "clases gratis disponibles",
      rewardProgress: "Te faltan {n} clases para tu próxima clase gratis.",
      totalBooked: "{n} clases reservadas en total.",
      history: "Historial de reservas",
      noBookings: "Aún no tienes reservas.",
      bookNow: "Reserva tu primera rodada →",
      bikes: "Bicis",
      byMembership: "Membresía",
      freeTag: "Clase gratis",
      reschedule: "Cambiar clase",
      profile: "Perfil",
      save: "Guardar cambios",
      saved: "Guardado ✓",
      guestTitle: "¿Reservaste sin cuenta?",
      guestSub: "Busca tus reservas con tu correo — sin necesidad de cuenta.",
      guestSearch: "Buscar",
      guestFound: "Tus reservas",
      guestNone: "No encontramos reservas para ese correo.",
    },
    manage: {
      overline: "*tu* RESERVA",
      heading: "CAMBIA *tu* CLASE.",
      loading: "Cargando tu reserva…",
      notFound: "No encontramos esa reserva. Revisa el enlace del correo de tu recibo.",
      genericError: "Algo salió mal. Inténtalo de nuevo.",
      receipt: "Recibo",
      yourClass: "Tu clase",
      coach: "Coach",
      spots: "Lugares",
      bikes: "Bicis",
      statusConfirmed: "Confirmada",
      statusOther: "Esta reserva ya no está activa.",
      movedNote: "Cambiada el {d}.",
      changeCta: "CAMBIAR MI CLASE",
      cancelChange: "Dejarla como está",
      pickTitle: "Elige la clase nueva",
      pickIntro: "La misma disciplina y la misma cantidad de lugares: no hay nada más que pagar. Solo aparecen las clases con espacio.",
      sameKindNote: "Tu reserva es de {kind}, así que puedes moverte a otra clase de {kind}.",
      kindRide: "spinning",
      kindFloor: "suelo",
      full: "Llena",
      noOptions: "Ahora mismo no hay otras clases con espacio. Escríbele al estudio y te ayudan.",
      confirmMove: "PÁSAME A ESTA CLASE",
      moving: "Cambiando…",
      moved: "Listo — tu clase quedó cambiada.",
      movedBody: "Te acabamos de enviar un recibo nuevo con el día y la hora correctos.",
      tooLate: "Falta menos de una hora para tu clase, así que ya no se puede cambiar por aquí. Llama al estudio al {phone} y te ayudan.",
      windowNote: "Puedes cambiar tu clase sin costo hasta {n} minutos antes de que empiece.",
      backHome: "← Volver al estudio",
      myAccount: "Mi cuenta →",
    },
    footer: {
      tagline: "Ciclismo indoor de lujo. Negro & oro.",
      hours: "Horario",
      hoursWeek: "Lun – Vie · desde 5:40 AM · tardes hasta 9:00 PM",
      hoursWeekend: "Sáb · 7:00 AM – 11:30 PM   ·   Dom · 8:30 AM",
      contact: "Contacto",
      rights: "Todos los derechos reservados.",
      madeBy: "Sitio hecho por",
      payments: "Pagos seguros procesados por Stripe.",
      stay: "Mantente en contacto con el estudio",
      emailPlaceholder: "Tu correo",
      subscribed: "Gracias — te mantendremos al tanto.",
      invalidEmail: "Ingresa un correo válido.",
      accessibility: "Accesibilidad",
      terms: "Términos & Condiciones",
      privacy: "Política de Privacidad",
    },
    booking: {
      overline: "*la* EXPERIENCIA APEX",
      chooseClass: "ELIGE *tu* CLASE",
      chooseBike: "ELIGE *tu* BICI",
      with: "con",
      spots: "bicis libres",
      soldOut: "AGOTADO",
      past: "FINALIZADA",
      back: "← Volver al horario",
      instructor: "INSTRUCTOR",
      legendAvailable: "Disponible",
      legendSelected: "Seleccionada",
      legendBooked: "Ocupada",
      mapHint: "Selecciona una o más bicis en el mapa.",
      summary: "TU RESERVA",
      bikes: "Bicis",
      bike: "Bici",
      perBike: "por bici",
      subtotal: "Subtotal",
      discount: "Descuento",
      total: "Total",
      coupon: "Código de cupón",
      apply: "APLICAR",
      couponInvalid: "Cupón inválido",
      couponApplied: "aplicado",
      name: "Nombre completo",
      email: "Correo electrónico",
      pay: "CONFIRMAR & PAGAR",
      processing: "PROCESANDO PAGO…",
      paymentsOff: "Los cobros con tarjeta no están activos en este momento.",
      payStripe: "PAGAR DE FORMA SEGURA",
      securePay: "Te llevaremos a la página segura de Stripe para pagar con tarjeta, Apple Pay o Google Pay. Nunca vemos ni guardamos los datos de tu tarjeta.",
      paySuccess: "Pago confirmado",
      payCanceled: "Pago cancelado — tus bicis quedaron libres.",
      payChecking: "Confirmando tu pago…",
      errRequired: "Completa tu nombre y correo.",
      errBikes: "Selecciona al menos una bici en el mapa.",
      errConflict: "Algunas de tus bicis acaban de ocuparse. Revisa el mapa.",
      // Clases de suelo (aeróbicos y dancefit): plaza, no bicicleta.
      chooseSpots: "RESERVA *tu* LUGAR",
      spotsLeft: "lugares libres",
      spotsHint: "Esta clase no lleva bicicleta: elige cuántos lugares necesitas.",
      howMany: "¿Cuántos lugares?",
      spotsLabel: "Lugares",
      spotLabel: "Lugar",
      perSpot: "por lugar",
      spotsAvailable: "disponibles",
      errSpots: "Elige al menos un lugar.",
      errSpotsConflict: "La clase acaba de llenarse. Elige menos lugares.",
      payCanceledSpots: "Pago cancelado — tus lugares quedaron libres.",
      floorNote: "Las clases de regalo se ganan y se usan solo en spinning.",
      hasPackageSignIn: "Este correo tiene un paquete activo. Inicia sesión para usarlo en esta reserva — si no, se te cobrará de nuevo.",
      signInToUse: "Iniciar sesión para usarlo",
      packageHint: "¿Vienes seguido? Con un paquete cada clase sale desde {p}.",
      seePackages: "Ver paquetes",
      min: "min",
      freeClassLine: "Clase gratis (recompensa)",
      freeClassAvailable: "Tienes una clase gratis — se aplicará a esta reserva.",
      rewardProgress: "Te faltan {n} clases para tu clase gratis.",
      membershipLine: "Cubre tu membresía",
      membershipUse: "Usar mi membresía",
      membershipLeft: "restantes",
      acceptTerms: "He leído y acepto los",
      termsLink: "Términos & Condiciones",
      errTerms: "Debes aceptar los Términos & Condiciones para reservar.",
      couponFirstOnly: "Ya usaste tu descuento de bienvenida.",
      couponOneClass: "de descuento en una clase",
      promoLine: "{pct}% en una clase, para usarlo cuando quieras — código",
      promoAtCheckout: "Tienes {pct}% de descuento en una clase con el código {code}. Lo aplicas al pagar, en la clase que tú elijas.",
      haveDiscount: "Tienes un 40% de descuento disponible",
      haveDiscountNote: "\u00dasalo en esta clase, o gu\u00e1rdalo para otra \u2014 es tuyo igual.",
      useDiscount: "USARLO AHORA",
      discountUsedUp: "Ya usaste tu descuento de bienvenida.",
      // El carrito: varias clases en una sola compra.
      addToCart: "AÑADIR A MI RESERVA",
      addToCartHint: "Añade todas las clases que quieras y págalas de una sola vez.",
      addedToCart: "Clase añadida. Elige otra, o ve a pagar.",
      alreadyInCart: "Esa clase ya está en tu reserva.",
      cartLimit: "Hasta {n} clases en una misma compra.",
      goToCart: "IR A PAGAR",
      addMore: "← Añadir otra clase",
      inCart: "AÑADIDA",
      cartHeading: "REVISA *tus* CLASES.",
      cartIntro: "Añade todas las clases que quieras y págalas de una vez — práctico si tienes paquete.",
      cartEmpty: "Todavía no has añadido ninguna clase.",
      remove: "Quitar",
      classWord: "clase",
      classesWord: "clases",
      seatWord: "lugar",
      seatsWord: "lugares",
      bikeWord: "bici",
      bikesWord: "bicis",
      refreshMap: "Actualizar disponibilidad",
    },
    receipt: {
      confirmed: "PAGO *confirmado.*",
      confirmedMany: "{n} CLASES *reservadas.*",
      changeNote: "Puedes cambiar cualquier clase desde tu recibo, hasta 60 minutos antes de que empiece.",
      receiptNo: "Recibo",
      klass: "Clase",
      date: "Fecha",
      time: "Hora",
      instructor: "Instructor",
      bikes: "Bicis",
      spots: "Lugares",
      total: "Total pagado",
      emailNote: "Se envió un recibo automático a",
      again: "RESERVAR OTRA RODADA",
      home: "VOLVER AL INICIO",
      rewardEarned: "🎉 ¡Ganaste una clase gratis! Lista para tu próxima reserva.",
    },
  },
};
